import React from 'react';

import { TextStyleKit } from '@tiptap/extension-text-style';
import { ReactNodeViewContentProvider } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import { renderToReactElement } from '@tiptap/static-renderer';

import type { RecursiveValue } from '../interfaces';
import AnalyticsWrapper from './AnalyticsWrapper';
import HeadingBlock, { HeadingBlockNodeExtension } from './HeadingBlock';

const RenderTiptapContent = ({
  config,
  contentBlock,
}: {
  config: Record<string, RecursiveValue>;
  contentBlock: Record<string, RecursiveValue>;
}) => {
  return (
    <AnalyticsWrapper
      shouldTrackImpression={config?.impression_tracking as boolean}
      trackingLocation={config?.analytics_location as string}
    >
      {renderToReactElement({
        content: contentBlock,
        extensions: [StarterKit, TextStyleKit, HeadingBlockNodeExtension],
        options: {
          nodeMapping: {
            heading: ({ children, node }) => {
              return (
                <ReactNodeViewContentProvider content={children}>
                  <HeadingBlock level={node.attrs.level} config={config} />
                </ReactNodeViewContentProvider>
              );
            },
          },
          unhandledNode: ({ node }) => {
            return `[unknown node ${node.type.name}]`;
          },
          unhandledMark: ({ mark }) => {
            return `[unknown node ${mark.type.name}]`;
          },
        },
      })}
    </AnalyticsWrapper>
  );
};

export default RenderTiptapContent;
